import { Box, Toolbar } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import React from 'react';
import Logo from '../../assets/LogoWithIcon.png';
import AppAvatar from '../AppAvatar';

export default function AppBar() {
    return (
        <MuiAppBar position='static' sx={{ mb: 3 }}>
            <Toolbar>
                <Box sx={{ mr: 'auto' }}>
                    <a href='/'>
                        <img style={{ width: 200 }} src={Logo} alt='Audiolo Icon'/>
                    </a>
                </Box>
                <AppAvatar />
            </Toolbar>
        </MuiAppBar>
    )
}